export default "__VITE_ASSET__ChPy4ZFN__"